import { createDocumentPage, getDocumentTextForType } from "./documentBaseUtils";

export function generatePrintTaximeterHtml(config, data, user, breakNewPage = false) {
    const { getDocumentText } = getDocumentTextForType(data, config);
    return createDocumentPage({title: 'AUTORIZAÇÃO', documentText: getDocumentText('INSTALACAO_TAXIMETRO'), config, data, user}, {showUserName: true, breakNewPage: breakNewPage})
}
